import { Box, NoSsr, StackProps } from "@mui/material";
import { Row } from "Components";
import { LISTING_FILTER_WIDTH } from "constants/layout";
import useMediaBreakpoints from "hooks/useMediaBreakpoints";
import { ReactNode } from "react";

type Props = {
  leftComponent?: ReactNode;
  rightComponent?: ReactNode;
};

const ListingFilterLayout = (props: StackProps & Props) => {
  const { leftComponent, rightComponent, ...rest } = props;
  const { isMobile } = useMediaBreakpoints();
  return (
    <NoSsr>
      <Row alignItems="flex-start" {...rest}>
        {!isMobile && (
          <Box width={LISTING_FILTER_WIDTH} minWidth={LISTING_FILTER_WIDTH}>
            {leftComponent}
          </Box>
        )}
        <Box
          flex={1}
          maxWidth={{
            xs: "100%",
            md: `calc(100% - ${LISTING_FILTER_WIDTH + 16}px)`,
          }}
          sx={{ marginLeft: "0 !important" }}
        >
          {rightComponent}
        </Box>
      </Row>
    </NoSsr>
  );
};

export default ListingFilterLayout;
